import formatCurrency from './formatCurrency';

const stringToInt = str => parseInt(str.replace(/\D/g,''));

const currencyStyle = digit => `R$ ${formatCurrency(digit)}`;

const inputCurrencyMask = (inputEl) => {
  function format(e) {
    if (['Backspace', 'Delete'].includes(e.key) && !isNaN(stringToInt(e.target.value))) {
      inputEl.value = currencyStyle(stringToInt(e.target.value));
    }
    if (/[0-9\/]+/.test(e.key)) {
      const buffer = stringToInt(e.target.value);
      const str = parseInt(buffer) > 0 ? buffer : e.key;
      e.target.value = `R$ ${formatCurrency(parseFloat(str))}`;
    }
  }
  inputEl.addEventListener('keyup', format);
  inputEl.addEventListener('touchend', format);
}

export default inputCurrencyMask
